import { Component, OnInit, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EventsService } from '../shared/events.service';
import { Event } from 'src/app/shared/models/Event';
import { SearchObjectResult } from '../../shared/models/SearchObject';
import { Observable } from 'rxjs';
import { EventSearchCriteria } from '../shared/event-search-criteria.model';
import { DataTableColumn } from '../../shared/data-table/data-table.component';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from 'src/app/shared/shared.service';
import { Option } from 'src/app/shared/select/select.component';
import { Village } from 'src/app/shared/models/Village';
import { LanguageEnum } from 'src/app/shared/enums/LanguageEnum';
import { RequestedRouterType } from 'src/app/shared/models/RequestedRouterType';
import { RouterDevice } from 'src/app/shared/models/Router';
import { RequestedSoftwareType } from 'src/app/shared/models/RequestedSoftwareType';
import { DeviceUser } from 'src/app/shared/models/DeviceUser';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as XLSX from "xlsx";
import moment from 'moment';

@Component({
    selector: 'app-all-events',
    templateUrl: './all-events.component.html',
    styleUrls: ['./all-events.component.scss'],
    standalone: false
})
export class AllEventsComponent implements OnInit {

  @ViewChild('exportTable') exportTable: any;

  public eventToUpdate: Event = new Event();
  public currentStatus: number = undefined;
  public hideEditEventContainer = true;
  public hideEditBody = true;
  public villageOptions: Option[] = [];
  public eventVillage = undefined;

  public exportEvent = null;
  public eventPaidIdArray: number[] = [];

  public clientLanguageArray: Option[] = [
    { value: 'de', label: LanguageEnum.DE },
    { value: 'it', label: LanguageEnum.IT },
    { value: 'en', label: LanguageEnum.EN },
  ];

  public tBodyTrAdditionalClass = 'alternateBgColor';

  private _villageObjects: Village[];

  loadPage: (page: number, pageSize: number) => Observable<SearchObjectResult<Event>> = null;
  filters: EventSearchCriteria = {};

  @ViewChild('editColumn', { static: false })
  editColumn: TemplateRef<any>;

  @ViewChild('idColumn', { static: true })
  idColumn: TemplateRef<any>;

  @ViewChild('eventNameColumn', { static: true })
  eventNameColumn: TemplateRef<any>;

  @ViewChild('startDateColumn', { static: true })
  startDateColumn: TemplateRef<any>;

  @ViewChild('endDateColumn', { static: true })
  endDateColumn: TemplateRef<any>;

  @ViewChild('pickUpDateColumn', { static: true })
  pickUpDateColumn: TemplateRef<any>;

  @ViewChild('returnDateColumn', { static: true })
  returnDateColumn: TemplateRef<any>;

  @ViewChild('villageColumn', { static: true })
  villageColumn: TemplateRef<any>;

  // @ViewChild('customerNameColumn')
  // customerNameColumn: TemplateRef<any>;

  @ViewChild('companyColumn', { static: true })
  companyColumn: TemplateRef<any>;

  @ViewChild('statusColumn', { static: true })
  statusColumn: TemplateRef<any>;

  @ViewChild('onlineColumn', { static: true })
  onlineColumn: TemplateRef<any>;

  @ViewChild('hasDeviceUsersColumn', { static: true })
  hasDeviceUsersColumn: TemplateRef<any>;

  @ViewChild('hasPriceListColumn', { static: true })
  hasPriceListColumn: TemplateRef<any>;

  @ViewChild('hasPrintersColumn', { static: true })
  hasPrintersColumn: TemplateRef<any>;

  @ViewChild('hasRoutersColumn', { static: true })
  hasRoutersColumn: TemplateRef<any>;

  @ViewChild('hasDevicesColumn', { static: true })
  hasDevicesColumn: TemplateRef<any>;

  @ViewChild('hasDataColumn', { static: true })
  hasDataColumn: TemplateRef<any>;

  @ViewChild('isPaidColumn', { static: true })
  isPaidColumn: TemplateRef<any>;

  @ViewChild('actionsColumn', { static: true })
  actionsColumn: TemplateRef<any>;

  columns: DataTableColumn[];

  public deletePin: string;

  public deleteEvent: any;
  public deleteEventName: string;
  public wrongPasswordError = false;

  constructor(private _route: ActivatedRoute, private _eventsService: EventsService, private _toastr: ToastrService, private titleService: Title,
    private _sharedService: SharedService, private _modalService: NgbModal) {
  }

  ngOnInit() {
    this.titleService.setTitle("Events - FAdminFrontend");
    this._route.queryParamMap.subscribe(params => {
      if (params.get('status')) {
        this.currentStatus = Number(params.get('status'));
        this.filters.status = params.get('status');
      }
      this.loadPage = (page: number, pageSize: number) => this._eventsService.search(page, pageSize, this.filters);
      this._sharedService.getAllVillages().subscribe(result => {
        this._villageObjects = result;
        result.forEach(village => {
          this.villageOptions.push({ value: village.id, label: village.name });
        });
        this.villageOptions = [...this.villageOptions];
      });
    });
    this.columns = [
      {
        name: 'id',
        displayed: true,
        translationKey: 'Id',
        template: this.idColumn,
        sortable: true,
        additionalClass: 'red-bg'
      },
      {
        name: 'eventName',
        displayed: true,
        translationKey: 'Event Name',
        template: this.eventNameColumn,
        sortable: true
      },
      {
        name: 'startDate',
        displayed: true,
        translationKey: 'Start Date',
        template: this.startDateColumn,
        sortable: true
      },
      {
        name: 'endDate',
        displayed: true,
        translationKey: 'End Date',
        template: this.endDateColumn,
        sortable: true
      },
      {
        name: 'pickUpDate',
        displayed: true,
        translationKey: 'Pick up Date',
        template: this.pickUpDateColumn,
        sortable: true
      },
      {
        name: 'returnDate',
        displayed: true,
        translationKey: 'Return Date',
        template: this.returnDateColumn,
        sortable: true
      },
      {
        name: 'village',
        displayed: true,
        translationKey: 'Village',
        template: this.villageColumn,
        sortable: true
      },
      // {
      //   name: 'customerNameColumn',
      //   displayed: true,
      //   translationKey: 'Customer Name',
      //   template: this.customerNameColumn,
      //   sortable: true
      // },
      {
        name: 'company',
        displayed: true,
        translationKey: 'Organization',
        template: this.companyColumn,
        sortable: true
      },
      {
        name: 'status',
        displayed: true,
        translationKey: 'Status',
        template: this.statusColumn,
        sortable: true
      },
      {
        name: 'onlineStatus',
        displayed: true,
        translationKey: 'Online',
        template: this.onlineColumn,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'hasDeviceUser',
        displayed: true,
        translationKey: 'Device users',
        template: this.hasDeviceUsersColumn,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'hasPriceList',
        displayed: true,
        translationKey: 'Pricelist',
        template: this.hasPriceListColumn,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'hasPrinters',
        displayed: true,
        translationKey: 'Printers',
        template: this.hasPrintersColumn,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'hasRouter',
        displayed: true,
        translationKey: 'Routers',
        template: this.hasRoutersColumn,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'hasDevices',
        displayed: true,
        translationKey: 'Devices',
        template: this.hasDevicesColumn,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'hasData',
        displayed: true,
        translationKey: 'Data',
        template: this.hasDataColumn,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'isPaid',
        displayed: true,
        translationKey: 'Paid',
        template: this.isPaidColumn,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'actions',
        displayed: true,
        translationKey: '',
        template: this.actionsColumn,
        sortable: true,
        additionalClass: 'text-right',
        trAddidionalClass: 'text-right'
      },
    ];
  }

  onTableReset() {
    if (this.currentStatus) {
      this.filters.status = this.currentStatus.toString();
    }
  }

  onUpdateEventButtonClick(eventId: string, target: HTMLElement) {
    this.hideEditEventContainer = false;
    target.scrollIntoView();
    this._eventsService.getEventById(eventId).subscribe(result => {
      this.eventToUpdate = result;
      this.hideEditBody = false;
    });
  }

  onEditCancelButtonClick() {
    this.eventToUpdate = new Event();
    this.hideEditEventContainer = true;
    this.hideEditBody = true;
  }

  onEditButtonClick() {
    if (this.eventToUpdate.eventName !== '') {
      if (this.eventVillage) {
        this.eventToUpdate.village = this._villageObjects.filter(village => village.id === this.eventVillage.value)[0];
      }
      this._eventsService.updateEvent(this.eventToUpdate).subscribe(result => {
        this._toastr.success('Event successfully updated');
        this.onEditCancelButtonClick();
        this.loadPage = (page: number, pageSize: number) => this._eventsService.search(page, pageSize, this.filters);
      }, error => {
        console.log(error);
      });
    }
  }

  checkRequestedPrinterQuantity(requestedSoftwareTypes: any, associatedPrinter: any): boolean {
    let requestedQuantity = 0;
    requestedSoftwareTypes.map(function (req) {
      if (req.softwareType.id === 4) {
        requestedQuantity += req.quantity;
      }
    });
    return (requestedQuantity === associatedPrinter.length ? true : false);
  }

  checkRequestedRouterQuantity(requestedRouters: RequestedRouterType[], associatedRouters: RouterDevice[]): boolean {
    let requestedQuantity = 0;
    requestedRouters.map(req => requestedQuantity += req.quantity);
    return (requestedQuantity === associatedRouters.length ? true : false);
  }

  checkRequestedDeviceUsersQuantity(requestedSoftwareTypes: RequestedSoftwareType[], deviceUsers: DeviceUser[]): boolean {
    let requestedQuantity = 0;
    requestedSoftwareTypes.map(function (req) {
      if (req.softwareType.id !== 4) {
        requestedQuantity += req.quantity;
      }
    });
    return (requestedQuantity === deviceUsers.length ? true : false);
  }

  checkDevicesOfDeviceUsers(deviceUsers: DeviceUser[]): boolean {
    if (deviceUsers.length === 0) {
      return false;
    }
    let hasDevices = true;
    deviceUsers.map(function (dev) {
      if (!dev.device) {
        hasDevices = false;
      }
    });
    return hasDevices;
  }

  changeOnlinePublish(newStatus: boolean, eventId: string) {
    this._eventsService.publishEventOnline(newStatus.toString(), eventId).subscribe(result => {
      this.loadPage = (page: number, pageSize: number) => this._eventsService.search(page, pageSize, this.filters);
    });
  }

  onDeleteButtonClick(eventId: string, modal, eventName) {
    this.deleteEvent = eventId;
    this.deleteEventName = eventName;
    this._modalService.open(modal);
  }

  onDeleteConfirm() {
    this.wrongPasswordError = false;
    this._eventsService.hardDeleteEvent(this.deleteEvent, this.deletePin).subscribe(res => {
      this._modalService.dismissAll();
      this._toastr.success('Event successfully deleted');
      window.location.reload();
    }, error => {
      if (error.status === 603) {
        this.wrongPasswordError = true;
        return;
      }
      this._modalService.dismissAll();
      this._toastr.error("There was an error deleting the event");
    });
  }

  onExcelExportClick(eventId) {
    this._eventsService.getEventPrintData(eventId).subscribe(result => {
      if (result[0].turnOver?.length > 0) {
        this.exportEvent = [];
        result[0].turnOver.forEach(t => {
          t.order.forEach(o => {
            const start = new Date(o.createdAt);
            const end = new Date(o.printedAt);
            const duration = (end.getTime() - start.getTime()) / (24 * 60 * 60 * 1000);
            this.exportEvent.push({
              DeviceUser: t.deviceUserName,
              CreatedAt: moment(o.createdAt).format('DD.MM.YYYY HH:mm:ss'),
              PrintedAt: moment(o.printedAt).format('DD.MM.YYYY HH:mm:ss'),
              TimeDiff: duration
            })
          })
        });
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.exportEvent, {cellDates: true});
        const range = XLSX.utils.decode_range(ws['!ref']);

        for (let r = range.s.r + 1; r <= range.e.r; ++r) {
          const cell_addr = XLSX.utils.encode_cell({ c: 3, r: r });
          const cell = ws[cell_addr];

          if (cell && cell.t === 'n') {
              cell.z = 'hh:mm:ss';
          }
        }

        ws['!cols'] = [
          { wch: 10 },
          { wch: 20 },
          { wch: 20 },
          { wch: 15 }
        ];

        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        XLSX.writeFile(wb, result[0].eventName + ' Print Data.xlsx');
      } else {
        this._toastr.error("This event doesnt have any data");
      }
    });
  }

  updateEventPaidStatus(id, isPaid) {
    this._eventsService.updateEventPaidStatus(id, isPaid).subscribe(res => {
      this._toastr.success("Status updated successfully");
      this.eventPaidIdArray.push(id);
    });
  }

  getEventPaid(id) {
    return this.eventPaidIdArray.includes(id);
  }

}
